import logToConsole from '@/utils/consoleHelper'

export default {
  USER_REQUESTED(state) {
    state.status = 'loading'
  },
  USER_SUCCESS(state) {
    logToConsole('Setting status to success', 'debug')
    state.status = 'success'
    logToConsole('Setting loaded to true', 'debug')
    state.loaded = true
  },
  USER_FAILURE: state => {
    logToConsole('Setting status to failure', 'debug')
    state.status = 'failure'
    logToConsole('Setting loaded to false', 'debug')
    state.loaded = false
  },
  USER_RESET(state) {
    state.user = Object.assign({}, {})
    state.loaded = false
    state.status = 'ready'
    localStorage.removeItem('user_profile')
    logToConsole('Stored user information cleared', 'debug')
  },
  USER_LOAD(state, payload) {
    logToConsole('Loading user object', 'debug')
    state.user = Object.assign({}, payload)
    logToConsole('User object loaded', 'debug')
  },
  USER_SAVE(state, payload) {
    logToConsole('Saving user object', 'debug')
    localStorage.setItem('user_profile', JSON.stringify(payload))
    logToConsole('User object saved', 'debug')
  },
  USER_PASSWORD_CHANGED() {
    logToConsole('Password successfully changed', 'debug')
  },
  USER_MASQUERADE_REQUESTED(state, payload) {
    logToConsole('User has requested to masquerade as user ' + payload, 'debug')
  },
  USER_MASQUERADE_SUCCESS(state) {
    logToConsole('Setting masquerade status to success', 'debug')
    state.masqueraded = true
  },
  USER_MASQUERADE_FAILURE(state) {
    logToConsole('Setting masquerade status to failure', 'debug')
    state.masqueraded = false
  },
  CHECK_IF_USER_IS_MASQUERADING(state, authUserID) {
    if (state.loaded === true && parseInt(state.user.id) !== authUserID) {
      logToConsole(
        state.user.id +
          ' is != ' +
          state.auth.user_id +
          ' user must be masquerading',
        'debug'
      )
      state.masqueraded = true
    } else {
      state.masqueraded = false
    }
  }
}
